import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Recruiter from "./Recruiter";

@Model()
class RecruiterJobMetric extends ApplicationRecord {
  static jsonapiType = "recruiter_job_metrics";

  @Attr() applicationsToInterviewPercent: number;

  @Attr() interviewsConfirmed: number;

  @Attr() placementsMade: number;

  @Attr() totalJobs: number;

  @BelongsTo(Recruiter) recruiter: Recruiter;
}

export default RecruiterJobMetric;
